let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("9LlD6"), load("5i5pX")]).then(() => parcelRequire('ltRMD'));